import { render, staticRenderFns } from "./TaskFilters.vue?vue&type=template&id=de286c62&scoped=true"
import script from "./TaskFilters.vue?vue&type=script&lang=js"
export * from "./TaskFilters.vue?vue&type=script&lang=js"
import style0 from "./TaskFilters.vue?vue&type=style&index=0&id=de286c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de286c62",
  null
  
)

export default component.exports